module.exports = __webpack_public_path__ + "static/media/rectangle-dsktp-logged-out.eb8bc203.png";